import * as _ from 'lodash'
import {IBusinessObject, IBusinessObjectChanges, IBusinessObjectChangesOptions} from '../PA.Core/PA.Core.IF.BO';
import {IMessageProvider, IProgressProvider, MessageType} from '../PA.Core/PA.Core.IF.Basic';
import {PAdbContext} from '../PA.Core/PAdbContext';
import {IdentityProvider} from '../PA.Core/Basic/Identity'
import {MessageProvider} from '../PA.Core/Basic/Messages'
import {ProgressProvider} from '../PA.Core/Basic/Progress'
import {
    WB_CompanyRow,
    WB_CompanyTextRow, 
    WB_DistribChannelRow,
    WB_DistribChannelTextRow,
    WB_DivisionRow,
    WB_DivisionTextRow,
    WB_MasterDataSetRow,
    WB_SalesAreaRow,
    WB_SalesAreaTextRow,
    WB_SalesOrgRow,
    WB_SalesOrgTextRow,
    WB_SetsRow,
    WB_SourceRow,
    WB_SourceSetTypeRow,
    WB_SourceTypeSTRRow
} from "../PA.Core/PAdbSchemaRows";
import {IwbMasterDataSet} from "../PA.Core/PAdbSchemaRowsIF";
import {
    esWB_Company,
    esWB_Company_Text,
    esWB_Customer_Calendar,
    esWB_Customer_External_Relationship, esWB_Customer_Type,
    esWB_DistribChannel,
    esWB_DistribChannel_Text,
    esWB_Division,
    esWB_Division_Text,
    esWB_LiftAPI,
    esWB_MasterData_Set, esWB_Product_Type,
    esWB_SalesArea,
    esWB_SalesArea_Text,
    esWB_SalesOrg,
    esWB_SalesOrg_Text,
    esWB_Set,
    esWB_Source,
    esWB_Source_SetType,
    esWB_SourceTypeSTR
} from "../PA.Core/PAdbSchema";
import {ESRecord} from "../PA.Core/lib/ESRecord";
import {ESDataStore} from "../PA.Core/lib/ESDataStore";
import {CreateOptions, ESRecordResolver} from "../PA.Core/lib/ESRecordResolver";
import {ASync} from "../PA.Core/Basic/ASync";

import {PAEnvironment} from "../PA.Core/PAEnvironment";
import {DefaultChanges} from "../PA.Core/BusinessObject/BusinessObjectChanges";
import {BehaviorSubject} from "rxjs";
import {ExecutionSerializer} from "../PA.Core/Basic/ExecutionSerializer";
import {SourceKeySet_getStats} from "../PA.Core/PAdbUtils";
import {MasterDataSetBOValidations} from "./MasterDataSetBO.Validations";
import {LeaseRegistry} from "../PA.Utils/LeaseRegistry";
import {IEntityMetaData} from "../PA.MD.Core/PA.MD.IF.Entity";
import {EntityMetaDataManager} from "../PA.MD.Core/EntityMetaDataManager";
import {IJobParamCreateLoadOptions, IJobParam} from "../PA.Job.Core/PA.Job.IF.JobParam";
import {JobParamManager} from "../PA.Job.Core/JobParamManager";
import {CustomerTypeBO} from "./CustomerTypeBO";
import {ProductTypeBO} from "./ProductTypeBO";

export class MasterDataSetBO
    implements IBusinessObject
{
    Identity: IdentityProvider;

    CreateOptions: any;

    LoadOptions: any;
    _bIsLoaded: boolean;
    _OnLoadComplete: Promise<IBusinessObject>;
    LoadProgressProvider: IProgressProvider;

    ValidateOptions: any;
    _bIsValidated: boolean;
    ValidateMessageProvider: IMessageProvider;
    ValidateProgressProvider: IProgressProvider;

    SaveOptions: any;
    _bIsSaved: boolean;
    SaveProgressProvider: IProgressProvider;

    DeleteOptions: any;
    _bIsDeleted: boolean;
    DeleteMessageProvider: IMessageProvider;
    DeleteProgressProvider: IProgressProvider;

    dbContext: PAdbContext;
    drWB_MasterDataSet: WB_MasterDataSetRow;

    dctCustomerTypes: {[custMId: string]: { defaultName: string}}
    dctProductTypes: {[prdMId: string]: { defaultName: string}}



    constructor(options?: any) {

        this.CreateOptions = options || {};

        if ('dbContext' in this.CreateOptions)
            this.dbContext = this.CreateOptions.dbContext;

        this.Identity = new IdentityProvider({id: 0, name: 'New Master Data Set'});

        this.LoadOptions = {};
        this._bIsLoaded = false;
        this._OnLoadComplete = undefined;
        this.LoadProgressProvider = new ProgressProvider('Loading', this);

        this.ValidateOptions = {};
        this._bIsValidated = false;
        this.ValidateMessageProvider = new MessageProvider();
        this.ValidateProgressProvider = new ProgressProvider("Validating", this);

        this.SaveOptions = {};
        this._bIsSaved = false;
        this.SaveProgressProvider = new ProgressProvider("Saving", this);

        this.DeleteOptions = {};
        this._bIsDeleted = false;
        this.DeleteMessageProvider = new MessageProvider();
        this.DeleteProgressProvider = new ProgressProvider("Deleting", this);

        this.drWB_MasterDataSet = undefined;

        this.dctCustomerTypes = {
            'ShipTo': {
                defaultName: "Ship To"
            },
            'SoldTo': {
                defaultName: "Sold To"
            },
            'BillTo': {
                defaultName: "Bill To"
            },
            'PayTo': {
                defaultName: "Pay To"
            },
            'PlanTo': {
                defaultName: "Plan To"
            }
        }

        this.dctProductTypes = {
            'ConsumerProduct': {
                defaultName: "Consumer UPC"
            },
            'FinishedProduct': {
                defaultName: "Finished Product"
            }
        }



        this.IMasterDataSet_init();
        this.ISourceSet_init()
        this.IEnterpriseSetup_init();
        this.IEntity_init();
    }



    get WB_MasterDataSet():WB_MasterDataSetRow{
        return  this.drWB_MasterDataSet;
    }
    //<editor-fold desc = "IBusinessObject operations">

    async LoadNew(options?: object): Promise<IBusinessObject> {
        const self = this;

        self.LoadProgressProvider.start("Creating Master Data Set");
        let rv = self._OnLoadComplete = (async () => {

            self.LoadOptions = options || {};
            if ('dbContext' in self.LoadOptions)
                self.dbContext = self.LoadOptions.dbContext;
            else
                self.dbContext = new PAdbContext();

            if (_.isEmpty(self.dbContext)) {
                let sError = "Unable to determine dbContext for new Master Data Set.";
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(sError);

                return self;
            }


            try {
                // Create record using dbContext
                let newMDSetRow: WB_MasterDataSetRow = <WB_MasterDataSetRow>await self.dbContext.createRecordWithKey(esWB_MasterData_Set)
                newMDSetRow.setDefaults()
                self.drWB_MasterDataSet = newMDSetRow;
                self.dbContext.add(esWB_MasterData_Set, newMDSetRow)
                self.Identity.setAll(self.WB_MasterDataSet.cif.WB_MDSET_ID, self.WB_MasterDataSet.cif.MDSET_ID, self.WB_MasterDataSet.cif.MDSET_NAME);
                self.Identity.listenToRecordUpdates(self.WB_MasterDataSet, 'WB_MDSET_ID', 'MDSET_ID', 'MDSET_NAME')
                self.Identity.enableRecordWriteBack(self.WB_MasterDataSet, "MDSET_ID", 'MDSET_NAME')

                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                return self;
            } catch (err) {
                self.LoadProgressProvider.exception(err)
                return self
            }

        })();

        return rv;
    }

    async Load(anId: number | number, options?: object): Promise<IBusinessObject> {

        const self = this;

        let recordResolver: ESRecordResolver
        let recordResolverLoadPromise: Promise<void>

        self.LoadProgressProvider.start("Loading (" + anId + ")");

        let rv = self._OnLoadComplete = (async () => {

            self.LoadProgressProvider.start("Loading (" + self.Identity.id_ui + ")");

            if (self.bIsLoaded) {
                self.LoadProgressProvider.exception("Master Data Set already loaded.");
                self._OnLoadComplete = undefined;
                return self;
            }

            self.LoadOptions = options || {};

            try {
                if ('dbContext' in self.LoadOptions)
                    self.dbContext = self.LoadOptions.dbContext;
                else if (_.isEmpty(self.dbContext)) {
                    self.dbContext = new PAdbContext({});
                }

                if (_.isEmpty(self.dbContext)) {
                    self.LoadProgressProvider.exception("Unable to determine dbContext for Master Data Set.");
                    return self;
                }


                if ('RecordResolver' in self.LoadOptions) {
                    recordResolver = (<any>self.LoadOptions).RecordResolver
                    recordResolverLoadPromise = ASync.resolve()
                } else {
                    recordResolver = MasterDataSetBO.createRecordResolver({dbContext: self.dbContext})
                    recordResolverLoadPromise = MasterDataSetBO.setupRecordResolver(recordResolver, [anId])
                }


                await recordResolverLoadPromise
                let aMasterDataSetRow: any = recordResolver.get(esWB_MasterData_Set, anId)

                if (_.isEmpty(aMasterDataSetRow)) {
                    throw "Master Data Set not found";
                }

                self.drWB_MasterDataSet = aMasterDataSetRow;
                self.Identity.setAll(self.WB_MasterDataSet.cif.WB_MDSET_ID, self.WB_MasterDataSet.cif.MDSET_ID, self.WB_MasterDataSet.cif.MDSET_NAME);
                self.Identity.listenToRecordUpdates(self.WB_MasterDataSet, 'WB_MDSET_ID', 'MDSET_ID', 'MDSET_NAME')
                self.Identity.enableRecordWriteBack(self.WB_MasterDataSet, "MDSET_ID", 'MDSET_NAME')
                self.LoadProgressProvider.setName("Loading " + self.Identity.name + "(" + self.Identity.id_ui + ")");

                await self._AfterBoLoadCompleteInternal()
                self._bIsLoaded = true;
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.finish();
                return self;
            } catch
                (err) {
                self._OnLoadComplete = undefined;
                self.LoadProgressProvider.exception(err);
                throw err
            }

        })();

        return rv;
    }


    get OnLoadComplete(): Promise<IBusinessObject> {
        return this._OnLoadComplete;
    }

    get bIsLoaded(): boolean {
        return this._bIsLoaded;
    }


    async Validate(options?: any): Promise<IBusinessObject> {

        const self = this;
        self.ValidateMessageProvider.clearMessages();
        self.ValidateProgressProvider.start("Validating " + self.WB_MasterDataSet.cif.MDSET_NAME + "(" + self.WB_MasterDataSet.cif.MDSET_ID + ")");

        self.ValidateOptions = options || {};
        try {
            if (_.isEmpty(self.dbContext)) {
                var sError = "Unable to determine dbContext for to Validate Master Data Set.";
                self.ValidateProgressProvider.exception(sError);
                return self;
            }
            await MasterDataSetBOValidations.Validate(self)

            self._bIsValidated = (self.ValidateMessageProvider.countMessages(MessageType.Error) == 0)
            self.ValidateProgressProvider.finish();

        } catch (err) {
            self.ValidateMessageProvider.addMessage({code: 'Exception', type: MessageType.Error, description: JSON.stringify(err), title: 'Validation Exception'})
            self._bIsValidated = false;
            self.ValidateProgressProvider.exception(err);
        }

        return self
    }

    get bIsValidated(): boolean {
        return this._bIsValidated;
    }


    Save(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(false, options)
    }

    SaveBatch(options?: any): Promise<IBusinessObject> {
        return this.SaveUsing(true, options)
    }

    async SaveUsing(bBatch: boolean, options?: any): Promise<IBusinessObject> {

        const self = this;
        self._bIsSaved = false
        const wbMasterDataSet = <IwbMasterDataSet>self.drWB_MasterDataSet;
        self.SaveProgressProvider.start("Saving " + wbMasterDataSet.MDSET_NAME + "(" + wbMasterDataSet.MDSET_ID + ")");
        try {
            // Doesn't need to do anything yet
            // All the records are in the store, since they were added through find or createNewRecord.
            // -- We could search the tree if the there is any record where store isn't set.

            if (_.isEmpty(this.dbContext)) {
                let sError = "Unable to determine dbContext to Save MD Set.";
                self.SaveProgressProvider.exception(sError);
                return self
            }
            self.SaveOptions = options || {};

            await self.Validate(options)
            if(self.ValidateMessageProvider.countMessages(MessageType.Error) > 0){
                self.SaveProgressProvider.finish();
                return self
            }

            let saveFunction: (esName: string, saveRecords: ESRecord[] | ESRecord, options?: any) => Promise<ESDataStore>
            if (bBatch) {
                saveFunction = self.dbContext.SaveBatch.bind(self.dbContext)
            } else {
                saveFunction = self.dbContext.Save.bind(self.dbContext)
            }

            await saveFunction(esWB_MasterData_Set, self.drWB_MasterDataSet, {})

            let tasks: Promise<any>[] = []

            tasks.push(saveFunction(esWB_Source, self.drWB_MasterDataSet.WB_SourceRows))
            tasks.push(saveFunction(esWB_Source_SetType, _.flatMap(self.WB_MasterDataSet.WB_SourceRows, (a) => a.WB_SourceSetTypeRow)))
            tasks.push(saveFunction(esWB_Set, self.drWB_MasterDataSet.WB_SetsRows))

            tasks.push(saveFunction(esWB_Division, self.drWB_MasterDataSet.WB_DivisionRows))
            tasks.push(saveFunction(esWB_Division_Text, _.flatMap(self.WB_MasterDataSet.WB_DivisionRows, (a) => a.WB_DivisionTextRows)))
            tasks.push(saveFunction(esWB_DistribChannel, self.drWB_MasterDataSet.WB_DistribChannelRows))
            tasks.push(saveFunction(esWB_DistribChannel_Text, _.flatMap(self.WB_MasterDataSet.WB_DistribChannelRows, (a) => a.WB_DistribChannelTextRows)))

            tasks.push(saveFunction(esWB_Company, self.drWB_MasterDataSet.WB_CompanyRows))
            tasks.push(saveFunction(esWB_Company_Text, _.flatMap(self.WB_MasterDataSet.WB_CompanyRows, (a) => a.WB_CompanyTextRows)))

            let SalesOrgs = _.flatMap(self.WB_MasterDataSet.WB_CompanyRows, (a) => a.WB_SalesOrgRows)
            tasks.push(saveFunction(esWB_SalesOrg, SalesOrgs))
            tasks.push(saveFunction(esWB_SalesOrg_Text, _.flatMap(SalesOrgs, (a) => a.WB_SalesOrgTextRows)))

            let SalesAreas = _.flatMap(SalesOrgs, (a) => a.WB_SalesAreaRows)
            tasks.push(saveFunction(esWB_SalesArea, SalesAreas))
            tasks.push(saveFunction(esWB_SalesArea_Text, _.flatMap(SalesAreas, (a) => a.WB_SalesAreaTextRows)))

            await Promise.all(tasks)

            if (self.EntityMetaData_Company) {
                await self.EntityMetaData_Company.Save(bBatch)
            }

            if (self.EntityMetaData_SalesOrg) {
                await self.EntityMetaData_SalesOrg.Save(bBatch)
            }

            if (self.EntityMetaData_SalesArea) {
                await self.EntityMetaData_SalesArea.Save(bBatch)
            }

            if (self.JobParamList) {
                const dctSalesOrg = _.keyBy(_.flatMap(self.WB_MasterDataSet.WB_CompanyRows, (a) => a.WB_SalesOrgRows), (b) => b.cif.WB_SALESORG_ID)
                for (const jobParam of self.JobParamList) {
                    let wbId = jobParam.wbSalesOrgId
                    if(wbId in dctSalesOrg){
                        let so = dctSalesOrg[wbId]
                        jobParam.id_ui = so.cif.SALESORG_ID
                        jobParam.name = so.cif.SALESORG_NAME
                    }
                    await jobParam.Save(bBatch);
                }
            }

            LeaseRegistry.invalidateLeasesByClass(LeaseRegistry.Lease_Subject_MasterDataSet)

            if (bBatch) {
                self.dbContext.addBatchCompleteListener(() => {
                    self._bIsSaved = true;
                })
            } else {
                self._bIsSaved = true;
            }
            self.SaveProgressProvider.finish();
            return self;
        } catch (err) {
            self.SaveProgressProvider.exception(err);
            return self
        }

    }

    get bIsSaved(): boolean {
        return this._bIsSaved;
    }


//Delete
    Delete(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(true, options)
    }

    DeleteOnSave(options?: any): Promise<IBusinessObject> {
        return this.DeleteUsing(false, options)
    }

    private async DeleteUsing(bSaveNow: boolean, options?: any): Promise<IBusinessObject> {
        const self = this;
        const wbMasterDataSet = <IwbMasterDataSet>self.drWB_MasterDataSet;

        this.DeleteMessageProvider.clearMessages();
        this.DeleteProgressProvider.start("Deleting " + wbMasterDataSet.MDSET_NAME + "(" + wbMasterDataSet.WB_MDSET_ID + ")");

        try {
            // 1. Validate if we can delete the Master Data Set
            await MasterDataSetBOValidations.ValidateDelete(self)
            if(self.DeleteMessageProvider.countMessages(MessageType.Error) > 0){
                return self
            }

            // 2. If Valid, mark all the records for deletion.
            self.drWB_MasterDataSet.markDeleted()

            _.forEach(self.drWB_MasterDataSet.WB_SourceRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
                _.forEach(a.WB_SourceSetTypeRow, (b) => {
                    if (b.isActive)
                        b.markDeleted()
                })
            })

            _.forEach(self.drWB_MasterDataSet.WB_SetsRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
            })

            _.forEach(self.drWB_MasterDataSet.WB_DivisionRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
                _.forEach(a.WB_DivisionTextRows, (b) => {
                    if (b.isActive)
                        b.markDeleted()
                })
            })

            _.forEach(self.drWB_MasterDataSet.WB_DistribChannelRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
                _.forEach(a.WB_DistribChannelTextRows, (b) => {
                    if (b.isActive)
                        b.markDeleted()
                })
            })

            _.forEach(self.drWB_MasterDataSet.WB_CompanyRows, (a) => {
                if (a.isActive)
                    a.markDeleted()
                _.forEach(a.WB_CompanyTextRows, (b) => {
                    if (b.isActive)
                        b.markDeleted()
                })
                _.forEach(a.WB_SalesOrgRows, (so) => {
                    if (so.isActive)
                        so.markDeleted()
                    _.forEach(so.WB_SalesOrgTextRows, (sot) => {
                        if (sot.isActive)
                            sot.markDeleted()
                    })
                    _.forEach(so.WB_SalesAreaRows, (sa) => {
                        if (sa.isActive)
                            sa.markDeleted()
                        _.forEach(sa.WB_SalesAreaTextRows, (sat) => {
                            if (sat.isActive)
                                sat.markDeleted()
                        })
                    })


                })
            })

            if(self.EntityMetaData_Company)
                await self.EntityMetaData_Company.Delete(bSaveNow)

            if(self.EntityMetaData_SalesOrg)
                await self.EntityMetaData_SalesOrg.Delete(bSaveNow)

            if(self.EntityMetaData_SalesArea)
                await self.EntityMetaData_SalesArea.Delete(bSaveNow)

            if (self.JobParamList) {
                for (const jobParam of self.JobParamList) {
                    await jobParam.Delete(bSaveNow);
                }
            }

            if (bSaveNow) {
                await self.SaveUsing(false)

                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return (self);
            } else {
                self._bIsDeleted = true;
                self.DeleteProgressProvider.finish();
                return self;
            }

        } catch (err) {
            self.DeleteProgressProvider.exception(err)
            return self
        }
    }

    get bIsDeleted(): boolean {
        return this._bIsDeleted;
    }

    private async _AfterBoLoadCompleteInternal(): Promise<void> {
        const self = this;
        let tasks: Promise<any>[] = [];
        self.LoadProgressProvider.setProgressMessage('MasterDataSetBO.PostLoad', 'Processing Loaded Data');
        tasks.push(self.IMasterDataSet_OnLoadComplete())
        await Promise.all(tasks)
        tasks = [self.ISourceSet_OnLoadComplete(), self.IEntity_OnLoadComplete()]
        await Promise.all(tasks)
        await self.IJobParam_OnLoadComplete();
        return
    }


    //</editor-fold>

    //<editor-fold desc = "BO Changes operation">

    Changes(options?: IBusinessObjectChangesOptions): IBusinessObjectChanges {
        let opts = options || {}
        opts.dctIncludeBelongsToNamedRelations = opts.dctIncludeBelongsToNamedRelations || {}
        opts.dctExcludeFields = opts.dctExcludeFields || {}
        opts.dctIgnoreChanges = opts.dctIgnoreChanges || {}

        opts.dctExcludeFields[esWB_Set] = ['USAGE_COUNT']
        opts.dctIgnoreChanges[esWB_Source_SetType] = {bNew: true, bDeletes: true}

        // Set any BO Specific change settings
        return DefaultChanges(this, this.WB_MasterDataSet, opts)
    }

    //</editor-fold>

    //<editor-fold desc = "MDSet Change Operations">
    private _onSourcePropertyChange: BehaviorSubject<{MasterDataSet: MasterDataSetBO, Source: WB_SourceRow, PropertyName: string, PropertyValue: any }>

    private IMasterDataSet_init(): void {
        this._onSourcePropertyChange = new BehaviorSubject<{MasterDataSet: MasterDataSetBO, Source: WB_SourceRow, PropertyName: string, PropertyValue: any }>(undefined)
    }


    private async IMasterDataSet_OnLoadComplete(): Promise<void> {
        const self = this
        for(let aRow of self.WB_MasterDataSet.WB_SourceRows) {
            aRow.setupOnChangeEvents([], self.ISource_onRecordChange.bind(self), self)
        }
    }

    private ISource_onRecordChange(record: WB_SourceRow, propertyName: string, propertyValue: any, options: MasterDataSetBO) {
        this.OnSourcePropertyChange.next({
            MasterDataSet: options,
            Source: record,
            PropertyName: propertyName,
            PropertyValue: propertyValue
        })
    }


    get OnSourcePropertyChange() {
        return this._onSourcePropertyChange
    }

    //</editor-fold>

    //<editor-fold desc = "Add Remove operations">
    private _onSourcesChanged: BehaviorSubject<MasterDataSetBO>
    private _onKeySetsChanged: BehaviorSubject<MasterDataSetBO>
    private _qsSourceSet_sync: ExecutionSerializer
    private _dctSourceTypeSets: {[id:number]: WB_SourceTypeSTRRow[]}

    private ISourceSet_init(): void {
        this._onSourcesChanged = new BehaviorSubject<MasterDataSetBO>(undefined)
        this._onKeySetsChanged = new BehaviorSubject<MasterDataSetBO>(undefined)
        this._qsSourceSet_sync = new ExecutionSerializer(this, this._SyncSourceSets.bind(this),
            [{}], 250, false)
    }
    private async ISourceSet_OnLoadComplete(): Promise<void> {
        const self = this

        self.OnSourcePropertyChange.subscribe((evt) => {
            if(_.isEmpty(evt))
                return

            switch(evt.PropertyName){
                case "WB_SOURCETYPE_ID":
                    self._qsSourceSet_sync.Run()
                    break;
            }
        })

        // Retrieve Key Stats
        let arrStats = await SourceKeySet_getStats({})
        _.forEach(self.WB_MasterDataSet.WB_SetsRows, (aSetRow) => {
            if(!aSetRow.isActive)
                return

            let wbSetId = aSetRow.cif.WB_SET_ID
            let SetType = aSetRow.cif.SET_TYPE
            let SetId = aSetRow.cif.SET_ID

            let setStats = _.filter(arrStats, (a) => (a.wbSetId == wbSetId) || ((a.SetId == SetId) && (a.SetType == SetType)))
            let totalRecords = 0
            _.forEach(setStats, (a) => totalRecords += a.RecordCount)
            aSetRow.cif.USAGE_COUNT = totalRecords
        })

        self._qsSourceSet_sync.Run()
    }


    get OnSourcesChanged() { return this._onSourcesChanged }
    get OnKeySetsChanged() { return this._onKeySetsChanged }


    async addSource(options?: any): Promise<WB_SourceRow> {
        const self = this

        let aNewRow: WB_SourceRow = <any>await self.dbContext.createRecordWithKey(esWB_Source)
        aNewRow.setDefaults()
        aNewRow.cif.WB_MDSET_ID = self.drWB_MasterDataSet.cif.WB_MDSET_ID
        aNewRow.WB_MasterDataSetRow = self.drWB_MasterDataSet
        self.dbContext.add(esWB_Source, aNewRow)

        // attached listener to new record
        aNewRow.setupOnChangeEvents([], self.ISource_onRecordChange.bind(self), self)

        self.OnSourcesChanged.next(self)

        return aNewRow
    }

    async removeSource(aWbSourceId: number): Promise<WB_SourceRow> {
        const self = this

        for (let aSrcRow of self.drWB_MasterDataSet.WB_SourceRows) {
            if (aSrcRow.isActive && aSrcRow.cif.WB_SOURCE_ID == aWbSourceId) {
                aSrcRow.markDeleted()
                _.forEach(aSrcRow.WB_SourceSetTypeRow, (a) => {a.markDeleted()} )
                self.OnSourcesChanged.next(self)
                return aSrcRow
            }
        }

        return undefined
    }

    async addSourceSetType(src: WB_SourceRow, setType: string, options?: any): Promise<WB_SourceSetTypeRow> {
        const self = this

        let aNewRow: WB_SourceSetTypeRow = <any> await self.dbContext.createRecordWithKey(esWB_Source_SetType)
        aNewRow.setDefaults()
        aNewRow.cif.WB_SOURCE_ID = src.cif.WB_SOURCE_ID
        aNewRow.WB_SourceRow = src
        aNewRow.cif.SET_TYPE = setType
        self.dbContext.add(esWB_Source_SetType, aNewRow)

        return aNewRow
    }

    async _SyncSourceSets(): Promise<void>{
        const self = this
        if(!self.WB_MasterDataSet)
            return

        if(_.isEmpty(self._dctSourceTypeSets)){
            self._dctSourceTypeSets = {}
            let arrSTSets = <WB_SourceTypeSTRRow> await self.dbContext.findAll(esWB_SourceTypeSTR, {where: {DELETED_IND: {neq: '1'}}})
            _.forEach(arrSTSets, (aRow: WB_SourceTypeSTRRow) => {
                let wbSourceTypeId = aRow.cif.WB_SOURCETYPE_ID
                if(wbSourceTypeId in self._dctSourceTypeSets){
                    self._dctSourceTypeSets[wbSourceTypeId].push(aRow)
                } else {
                    self._dctSourceTypeSets[wbSourceTypeId] = [aRow]
                }
            })
        }

        for(let aSourceRow of self.WB_MasterDataSet.WB_SourceRows){
            if(!aSourceRow.isActive)
                continue

            let wbSourceTypeId = aSourceRow.cif.WB_SOURCETYPE_ID
            let dct = _.keyBy(self._dctSourceTypeSets[wbSourceTypeId] || [], (a) => a.cif.SET_TYPE)

            let dctMissing = _.clone(dct)
            let dctExisting: {[id:string]: string} = {}

            // Check for deletes, duplicates, find missing
            _.forEach(aSourceRow.WB_SourceSetTypeRow, (aSourceSetTypeRow) => {
                if(!aSourceSetTypeRow.isActive)
                    return

                let setType = aSourceSetTypeRow.cif.SET_TYPE
                if(_.isEmpty(setType) || (setType in dctExisting) || (!(setType in dct))){
                    aSourceSetTypeRow.markDeleted()
                    return
                }

                dctExisting[setType] = setType
                if(setType in dctMissing){
                    delete dctMissing[setType]
                }

            })

            // Add Missing
            for(let aSetType of _.keys(dctMissing)){
                let aSTR = dct[aSetType]
                let dfltAlgorithm = ""
                if(!_.isEmpty(aSTR.cif.INTEGRATION_ALGORITHMS)) {
                    dfltAlgorithm = _.first(aSTR.cif.INTEGRATION_ALGORITHMS.split(",")) || ""
                }
                let newRow = await self.addSourceSetType(aSourceRow, aSetType, {})
                newRow.cif.INTEGRATION_ALGORITHM = dfltAlgorithm
            }

        } // Next Source

        self.OnSourcesChanged.next(self)

    }

    async addSet(setType?: string, setId?: string, setName?: string): Promise<WB_SetsRow> {
        const self = this

        let aNewRow: WB_SetsRow = <any> await self.dbContext.createRecordWithKey(esWB_Set)
        aNewRow.setDefaults()
        aNewRow.cif.WB_MDSET_ID = self.drWB_MasterDataSet.cif.WB_MDSET_ID
        aNewRow.WB_MasterDataSetRow = self.drWB_MasterDataSet
        aNewRow.cif.SET_TYPE = setType || ''
        aNewRow.cif.SET_ID = setId || ''
        aNewRow.cif.SET_NAME = setName || setId || ''
        self.dbContext.add(esWB_Set, aNewRow)

        self.OnKeySetsChanged.next(self)

        return aNewRow
    }

    async removeSet(aWbSetId: number): Promise<WB_SetsRow> {
        const self = this

        let rv: WB_SetsRow = undefined

        for (let wbSetsRow of self.drWB_MasterDataSet.WB_SetsRows) {
            if (wbSetsRow.isActive && wbSetsRow.cif.WB_SET_ID == aWbSetId) {
                wbSetsRow.markDeleted()
                rv = wbSetsRow
                break
            }
        }

        //-- Zero out any record refs
        for (let wbSourceRow of self.drWB_MasterDataSet.WB_SourceRows) {
            if(!wbSourceRow.isActive)
                continue
            for(let wbSS of wbSourceRow.WB_SourceSetTypeRow){
                if(!wbSS.isActive)
                    continue
                if(wbSS.cif.WB_SET_ID == aWbSetId)
                    wbSS.cif.WB_SET_ID = 0
            }
        }

        self.OnKeySetsChanged.next(self)
        return rv
    }

    get KeySets(): WB_SetsRow[] {
        let arr = _.filter(this.WB_MasterDataSet?.WB_SetsRows || [], (a) => a.isActive)
        return arr
    }

    //</editor-fold>

    //<editor-fold desc = "IEnterprise Setup operations">

    private _onCompaniesChanged: BehaviorSubject<MasterDataSetBO>
    private _onDivisionsChanged: BehaviorSubject<MasterDataSetBO>
    private _onDistribChannelChanged: BehaviorSubject<MasterDataSetBO>
    private _onSalesOrgsChanged: BehaviorSubject<MasterDataSetBO>
    private _onSalesAreasChanged: BehaviorSubject<MasterDataSetBO>

    private IEnterpriseSetup_init() {
        //--
        this._onCompaniesChanged = new BehaviorSubject<MasterDataSetBO>(undefined)
        this._onDivisionsChanged = new BehaviorSubject<MasterDataSetBO>(undefined)
        this._onDistribChannelChanged = new BehaviorSubject<MasterDataSetBO>(undefined)
        this._onSalesOrgsChanged = new BehaviorSubject<MasterDataSetBO>(undefined)
        this._onSalesAreasChanged = new BehaviorSubject<MasterDataSetBO>(undefined)
    }

    get OnCompaniesChanged(): BehaviorSubject<MasterDataSetBO> { return this._onCompaniesChanged }
    get OnDivisionsChanged(): BehaviorSubject<MasterDataSetBO> { return this._onDivisionsChanged }
    get OnDistribChannelsChanged(): BehaviorSubject<MasterDataSetBO> { return this._onDistribChannelChanged }
    get OnSalesOrgsChanged(): BehaviorSubject<MasterDataSetBO> { return this._onSalesOrgsChanged }
    get OnSalesAreasChanged(): BehaviorSubject<MasterDataSetBO> { return this._onSalesAreasChanged }

    //-- Company API
    async addCompany(options?: any): Promise<WB_CompanyRow> {
        const self = this

        let aNewRow: WB_CompanyRow = <any> await self.dbContext.createRecordWithKey(esWB_Company)
        aNewRow.setDefaults()
        aNewRow.cif.WB_MDSET_ID = self.drWB_MasterDataSet.cif.WB_MDSET_ID
        aNewRow.WB_MasterDataSetRow = self.drWB_MasterDataSet
        self.dbContext.add(esWB_Company, aNewRow)
        self.OnCompaniesChanged.next(self)
        return aNewRow
    }

    async removeCompany(aWbCompanyId: number): Promise<WB_CompanyRow> {
        const self = this

        let foundCompanyRow: WB_CompanyRow

        for (let wbCompanyRow of self.drWB_MasterDataSet.WB_CompanyRows) {
            if (wbCompanyRow.isActive && wbCompanyRow.cif.WB_COMPANY_ID == aWbCompanyId) {
                foundCompanyRow = wbCompanyRow
                break;
            }
        }

        let bChildDeleteFailed = false
        // try and delete all the children first.
        if (foundCompanyRow) {
            for (let aSalesOrg of foundCompanyRow.WB_SalesOrgRows) {
                if (aSalesOrg.isActive) {
                    let delSO = await self.removeSalesOrg(aSalesOrg.cif.WB_SALESORG_ID)
                    if (delSO?.isActive) {
                        bChildDeleteFailed = true
                        break;
                    }
                }
            }

            if (!bChildDeleteFailed)
                foundCompanyRow.markDeleted()

        }

        self.OnCompaniesChanged.next(self)

        return foundCompanyRow
    }

    canRemoveCompany(aWbCompanyId: number| WB_CompanyRow): boolean {
        const self = this

        let foundCompany: WB_CompanyRow

        if (_.isNumber(aWbCompanyId))
            for (let wbCompanyRow of self.drWB_MasterDataSet.WB_CompanyRows) {
                if (wbCompanyRow.isActive && wbCompanyRow.cif.WB_COMPANY_ID == aWbCompanyId) {
                    foundCompany = wbCompanyRow
                    break
                }
            }
        else
            foundCompany = aWbCompanyId

        if(!foundCompany)
            return false

        if(!foundCompany.bManualInd)
            return false

        // Check For Children
        for(let aSalesOrg of foundCompany.WB_SalesOrgRows){
            if(!aSalesOrg.isActive)
                continue;

            return false // Don't cascade check, simply any child will fail
            //if(!self.canRemoveSalesOrg(aSalesOrg))
            //    return false

        }

        return true
    }


    async addCompanyText(aCompanyRow: WB_CompanyRow, languageCd: string): Promise<WB_CompanyTextRow> {
        const self = this

        // Check for duplicate
        for(let aRow of aCompanyRow.WB_CompanyTextRows){
            if(aRow.isActive && (aRow.cif.LANGUAGE == languageCd))
                return aRow
        }

        let aNewRow: WB_CompanyTextRow = <any>await self.dbContext.createRecordWithKey(esWB_Company_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_COMPANY_ID = aCompanyRow.cif.WB_COMPANY_ID
        aNewRow.WB_CompanyRow = aCompanyRow
        aNewRow.cif.LANGUAGE = languageCd
        self.dbContext.add(esWB_Company_Text, aNewRow)
        return aNewRow
    }

    async removeCompanyText(aWbCompanyTextId: number): Promise<void> {
        const self = this

        let found = false
        _.forEach(self.drWB_MasterDataSet.WB_CompanyRows, (aCompanyRow) => {
            _.forEach(aCompanyRow.WB_CompanyTextRows, (aCTRow) => {
                if (aCTRow.isActive && aCTRow.cif.WB_COMPANYT_ID == aWbCompanyTextId) {
                    aCTRow.markDeleted()
                    found = true
                    return false
                }
            })
            if(found)
                return false
        })

    }

    // Division API
    async addDivision(options?: any): Promise<WB_DivisionRow> {
        const self = this

        let aNewRow: WB_DivisionRow = <any> await self.dbContext.createRecordWithKey(esWB_Division)
        aNewRow.setDefaults()
        aNewRow.cif.WB_MDSET_ID = self.drWB_MasterDataSet.cif.WB_MDSET_ID
        aNewRow.WB_MasterDataSetRow = self.drWB_MasterDataSet
        self.dbContext.add(esWB_Division, aNewRow)
        self.OnDivisionsChanged.next(self)
        return aNewRow
    }

    async removeDivision(aWbDivisionId: number): Promise<WB_DivisionRow> {
        const self = this

        let foundDivision
        for (let wbDivisionRow of self.drWB_MasterDataSet.WB_DivisionRows) {
            if (wbDivisionRow.isActive && wbDivisionRow.cif.WB_DIVISION_ID == aWbDivisionId) {
                foundDivision = wbDivisionRow
                break
            }
        }
        if(foundDivision)
            foundDivision.markDeleted()

        self.OnDivisionsChanged.next(self)

        return foundDivision
    }


    canRemoveDivision(aWbDivisionId: number): boolean {
        const self = this

        let foundDivision: WB_DivisionRow

        for (let divRow of self.drWB_MasterDataSet.WB_DivisionRows) {
            if (divRow.isActive && divRow.cif.WB_DIVISION_ID == aWbDivisionId) {
                foundDivision =  divRow
                break
            }
        }

        if(!foundDivision)
            return false

        if(!foundDivision.bManualInd)
            return false

        // Check Sales Areas
        let refSA = _.filter(self.SalesAreas, (a) => a.cif.WB_DIVISION_ID == foundDivision.cif.WB_DIVISION_ID)
        if(refSA.length)
            return false

        return true
    }


    async addDivisionText(aDivisionRow: WB_DivisionRow, languageCd: string): Promise<WB_DivisionTextRow> {
        const self = this

        // Check for duplicate
        for(let aRow of aDivisionRow.WB_DivisionTextRows){
            if(aRow.isActive && (aRow.cif.LANGUAGE == languageCd))
                return aRow
        }

        let aNewRow: WB_DivisionTextRow = <any>await self.dbContext.createRecordWithKey(esWB_Division_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_DIVISION_ID = aDivisionRow.cif.WB_DIVISION_ID
        aNewRow.WB_DivisionRow = aDivisionRow
        aNewRow.cif.LANGUAGE = languageCd
        self.dbContext.add(esWB_Division_Text, aNewRow)
        return aNewRow
    }

    async removeDivisionText(aWbDivisionTextId: number): Promise<void> {
        const self = this

        let found = false
        _.forEach(self.drWB_MasterDataSet.WB_DivisionRows, (aDivisionRow) => {
            _.forEach(aDivisionRow.WB_DivisionTextRows, (aDTRow) => {
                if (aDTRow.isActive && aDTRow.cif.WB_DIVISIONT_ID == aWbDivisionTextId) {
                    aDTRow.markDeleted()
                    found = true
                    return false
                }
            })
            if(found)
                return false
        })

    }

    // DistribChannel API
    async addDistribChannel(options?: any): Promise<WB_DistribChannelRow> {
        const self = this

        let aNewRow: WB_DistribChannelRow = <any> await self.dbContext.createRecordWithKey(esWB_DistribChannel)
        aNewRow.setDefaults()
        aNewRow.cif.WB_MDSET_ID = self.drWB_MasterDataSet.cif.WB_MDSET_ID
        aNewRow.WB_MasterDataSetRow = self.drWB_MasterDataSet
        self.dbContext.add(esWB_DistribChannel, aNewRow)
        self.OnDistribChannelsChanged.next(self)
        return aNewRow
    }

    async removeDistribChannel(aWbDistribChannelId: number): Promise<WB_DistribChannelRow> {
        const self = this

        let foundDistribChannel

        for (let wbDistribChannelRow of self.drWB_MasterDataSet.WB_DistribChannelRows) {
            if (wbDistribChannelRow.isActive && wbDistribChannelRow.cif.WB_DISTRIBCHANNEL_ID == aWbDistribChannelId) {
                foundDistribChannel =  wbDistribChannelRow
                break
            }
        }

        if(foundDistribChannel)
            foundDistribChannel.markDeleted()

        self.OnDistribChannelsChanged.next(self)

        return foundDistribChannel
    }

    canRemoveDistribChannel(aWbDistribChannelId: number): boolean {
        const self = this

        let foundDistribChannel: WB_DistribChannelRow

        for (let wbDistribChannelRow of self.drWB_MasterDataSet.WB_DistribChannelRows) {
            if (wbDistribChannelRow.isActive && wbDistribChannelRow.cif.WB_DISTRIBCHANNEL_ID == aWbDistribChannelId) {
                foundDistribChannel =  wbDistribChannelRow
                break
            }
        }

        if(!foundDistribChannel)
            return false

        if(!foundDistribChannel.bManualInd)
            return false

        // Check Sales Areas
        let refSA = _.filter(self.SalesAreas, (a) => a.cif.WB_DISTRIBCHANNEL_ID == foundDistribChannel.cif.WB_DISTRIBCHANNEL_ID)
        if(refSA.length)
            return false

        return true
    }

    async addDistribChannelText(aDistribChannelRow: WB_DistribChannelRow, languageCd: string): Promise<WB_DistribChannelTextRow> {
        const self = this

        // Check for duplicate
        for(let aRow of aDistribChannelRow.WB_DistribChannelTextRows){
            if(aRow.isActive && (aRow.cif.LANGUAGE == languageCd))
                return aRow
        }

        let aNewRow: WB_DistribChannelTextRow = <any>await self.dbContext.createRecordWithKey(esWB_DistribChannel_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_DISTRIBCHANNEL_ID = aDistribChannelRow.cif.WB_DISTRIBCHANNEL_ID
        aNewRow.WB_DistribChannelRow = aDistribChannelRow
        aNewRow.cif.LANGUAGE = languageCd
        self.dbContext.add(esWB_DistribChannel_Text, aNewRow)
        return aNewRow
    }

    async removeDistribChannelText(aWbDistribChannelTextId: number): Promise<void> {
        const self = this

        let found = false
        _.forEach(self.drWB_MasterDataSet.WB_DistribChannelRows, (aDistribChannelRow) => {
            _.forEach(aDistribChannelRow.WB_DistribChannelTextRows, (aDTRow) => {
                if (aDTRow.isActive && aDTRow.cif.WB_DISTRIBCHANNELT_ID == aWbDistribChannelTextId) {
                    aDTRow.markDeleted()
                    found = true
                    return false
                }
            })
            if(found)
                return false
        })

    }

    // SalesOrg API
    async addSalesOrg(aWB_Company: WB_CompanyRow, options?: any): Promise<WB_SalesOrgRow> {
        const self = this

        let aNewRow: WB_SalesOrgRow = <any> await self.dbContext.createRecordWithKey(esWB_SalesOrg)
        aNewRow.setDefaults()
        aNewRow.cif.WB_COMPANY_ID = aWB_Company.cif.WB_COMPANY_ID
        aNewRow.WB_CompanyRow = aWB_Company
        self.dbContext.add(esWB_SalesOrg, aNewRow)
        self.OnSalesOrgsChanged.next(self)
        // add job param for the new sales org
        await this.addJobParamForSalesOrg(aNewRow)
        return aNewRow
    }

    async removeSalesOrg(aWbSalesOrgId: number): Promise<WB_SalesOrgRow> {
        const self = this

        let foundSalesOrgRow: WB_SalesOrgRow

        for (let wbCompanyRow of self.drWB_MasterDataSet.WB_CompanyRows) {
            if (!wbCompanyRow.isActive)
                continue
            for (let wbSalesOrgRow of wbCompanyRow.WB_SalesOrgRows) {
                if (wbSalesOrgRow.isActive && wbSalesOrgRow.cif.WB_SALESORG_ID == aWbSalesOrgId) {
                    foundSalesOrgRow = wbSalesOrgRow
                    break
                }
            }
            if(foundSalesOrgRow)
                break
        }



        let bChildDeleteFailed = false
        // try and delete all the children first.
        if (foundSalesOrgRow) {
            for (let aSalesArea of foundSalesOrgRow.WB_SalesAreaRows) {
                if (aSalesArea.isActive) {
                    let delSA = await self.removeSalesArea(aSalesArea.cif.WB_SALESAREA_ID)
                    if (delSA?.isActive) {
                        bChildDeleteFailed = true
                        break;
                    }
                }
            }

            await self.removeJobParamForSalesOrg(foundSalesOrgRow)

            if (!bChildDeleteFailed)
                foundSalesOrgRow.markDeleted()

        }

        self.OnSalesOrgsChanged.next(self)

        return foundSalesOrgRow
    }

    canRemoveSalesOrg(aWbSalesOrgId: number| WB_SalesOrgRow): boolean {
        const self = this

        let foundSalesOrg: WB_SalesOrgRow
        if (_.isNumber(aWbSalesOrgId))
            for (let wbSalesOrgRow of self.SalesOrgs) {
                if (wbSalesOrgRow.cif.WB_SALESORG_ID == aWbSalesOrgId) {
                    foundSalesOrg = wbSalesOrgRow
                    break
                }
            }
        else
            foundSalesOrg = aWbSalesOrgId

        if(!foundSalesOrg)
            return false

        if(!foundSalesOrg.bManualInd)
            return false

        // Check For Children
        for(let aSalesArea of foundSalesOrg.WB_SalesAreaRows){
            if(!aSalesArea.isActive)
                continue;

            if(!self.canRemoveSalesArea(aSalesArea.cif.WB_SALESORG_ID))
                return false

        }

        return true
    }


    get Companies(): WB_CompanyRow[] {
        return _.filter(this?.WB_MasterDataSet?.WB_CompanyRows || [], (a) => a.isActive)
    }


    get SalesOrgs(): WB_SalesOrgRow[] {
        return _.filter( _.flatMap(this.Companies, (a) => a.WB_SalesOrgRows), (b) => b.isActive)
    }
    get SalesAreas(): WB_SalesAreaRow[] {
        return _.filter( _.flatMap(this.SalesOrgs, (a) => a.WB_SalesAreaRows), (b) => b.isActive)
    }

    async addSalesOrgText(aSalesOrgRow: WB_SalesOrgRow, languageCd: string): Promise<WB_SalesOrgTextRow> {
        const self = this

        // Check for duplicate
        for(let aRow of aSalesOrgRow.WB_SalesOrgTextRows){
            if(aRow.isActive && (aRow.cif.LANGUAGE == languageCd))
                return aRow
        }

        let aNewRow: WB_SalesOrgTextRow = <any>await self.dbContext.createRecordWithKey(esWB_SalesOrg_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_SALESORG_ID = aSalesOrgRow.cif.WB_SALESORG_ID
        aNewRow.WB_SalesOrgRow = aSalesOrgRow
        aNewRow.cif.LANGUAGE = languageCd
        self.dbContext.add(esWB_SalesOrg_Text, aNewRow)
        return aNewRow
    }

    async removeSalesOrgText(aWbSalesOrgTextId: number): Promise<void> {
        const self = this

        let found = false
        _.forEach(self.drWB_MasterDataSet.WB_CompanyRows, (aCompanyRow) => {
            _.forEach(aCompanyRow.WB_SalesOrgRows, (aSORow) => {
                if(!aSORow.isActive)
                    return
                _.forEach(aSORow.WB_SalesOrgTextRows, (aSOTRow) => {
                    if (aSOTRow.isActive && aSOTRow.cif.WB_SALESORGT_ID == aWbSalesOrgTextId) {
                        aSOTRow.markDeleted()
                        found = true
                        return false
                    }
                })
            })
            if(found)
                return false
        })

    }

    // SalesArea API

    // SalesOrg API
    async addSalesArea(aWB_SalesOrg: WB_SalesOrgRow, options?: any): Promise<WB_SalesAreaRow> {
        const self = this

        let aNewRow: WB_SalesAreaRow = <any> await self.dbContext.createRecordWithKey(esWB_SalesArea)
        aNewRow.setDefaults()
        aNewRow.cif.WB_SALESORG_ID = aWB_SalesOrg.cif.WB_SALESORG_ID
        aNewRow.WB_SalesOrgRow = aWB_SalesOrg
        self.dbContext.add(esWB_SalesArea, aNewRow)
        self.OnSalesAreasChanged.next(self)
        return aNewRow
    }

    async removeSalesArea(aWbSalesAreaId: number): Promise<WB_SalesAreaRow> {
        const self = this

        let foundSalesArea: WB_SalesAreaRow
        for (let wbCompanyRow of self.drWB_MasterDataSet.WB_CompanyRows) {
            if (!wbCompanyRow.isActive)
                continue

            for (let wbSalesOrgRow of wbCompanyRow.WB_SalesOrgRows) {
                if (!wbSalesOrgRow.isActive)
                    continue

                for (let wbSalesAreaRow of wbSalesOrgRow.WB_SalesAreaRows) {

                    if (wbSalesAreaRow.isActive && wbSalesAreaRow.cif.WB_SALESAREA_ID == aWbSalesAreaId) {
                        foundSalesArea = wbSalesAreaRow
                        break
                    }
                }
                if(foundSalesArea)
                    break
            }
            if(foundSalesArea)
                break
        }

        if(foundSalesArea)
            foundSalesArea.markDeleted()

        self.OnSalesAreasChanged.next(self)

        return foundSalesArea
    }

    canRemoveSalesArea(aWbSalesAreaId: number| WB_SalesAreaRow): boolean {
        const self = this

        let foundSalesArea: WB_SalesAreaRow
        if (_.isNumber(aWbSalesAreaId))
            for (let wbSalesAreaRow of self.SalesAreas) {
                if (wbSalesAreaRow.cif.WB_SALESAREA_ID == aWbSalesAreaId) {
                    foundSalesArea = wbSalesAreaRow
                    break
                }
            }
        else
            foundSalesArea = aWbSalesAreaId

        if(!foundSalesArea)
            return false

        if(!foundSalesArea.bManualInd)
            return false

        return true
    }

    async addSalesAreaText(aSalesAreaRow: WB_SalesAreaRow, languageCd: string): Promise<WB_SalesAreaTextRow> {
        const self = this

        // Check for duplicate
        for(let aRow of aSalesAreaRow.WB_SalesAreaTextRows){
            if(aRow.isActive && (aRow.cif.LANGUAGE == languageCd))
                return aRow
        }

        let aNewRow: WB_SalesAreaTextRow = <any>await self.dbContext.createRecordWithKey(esWB_SalesArea_Text)
        aNewRow.setDefaults()
        aNewRow.cif.WB_SALESAREA_ID = aSalesAreaRow.cif.WB_SALESAREA_ID
        aNewRow.WB_SalesAreaRow = aSalesAreaRow
        aNewRow.cif.LANGUAGE = languageCd
        self.dbContext.add(esWB_SalesArea_Text, aNewRow)
        return aNewRow
    }



    //</editor-fold>

    //<editor-fold desc = "Entity">
    _emdCompany: IEntityMetaData
    _emdSalesOrg: IEntityMetaData
    _emdSalesArea: IEntityMetaData

    IEntity_init(): void {
        // Nothing can be created here
    }

    async IEntity_OnLoadComplete(): Promise<void> {
        const self = this

        let eMgr = new EntityMetaDataManager()
        let metaWbId = this.WB_MasterDataSet.cif.WB_MDSET_ID
        let wbMasterDataSetId = this.WB_MasterDataSet.cif.WB_MDSET_ID


        this._emdCompany =  await eMgr.findOrCreate({
            dbContext: this.dbContext,
            appExecId: ["Company", "MasterDataSet"],
            dataObjectId: "/AZR/WB_COMPANY",
            dataObjectTypeId: "Table",
            setType: "Enterprise",
            metaType: "Company",
            metaWbId: metaWbId,
            wbMasterDataSetId: wbMasterDataSetId,
            entityId: "Company",
            entityName: "Company",
            dimensionId: "Enterprise"
        })

        this._emdSalesOrg =  await eMgr.findOrCreate({
            dbContext: this.dbContext,
            appExecId: ["SalesOrg", "MasterDataSet"],
            dataObjectId: "/AZR/WB_SALESORG",
            dataObjectTypeId: "Table",
            setType: "Enterprise",
            metaType: "SalesOrg",
            metaWbId: metaWbId,
            wbMasterDataSetId: wbMasterDataSetId,
            entityId: "SalesOrg",
            entityName: "Sales Organization",
            dimensionId: "Enterprise"
        })

        this._emdSalesArea =  await eMgr.findOrCreate({
            dbContext: this.dbContext,
            appExecId: ["SalesArea", "MasterDataSet"],
            dataObjectId: "/AZR/WB_SALESAREA",
            dataObjectTypeId: "Table",
            setType: "Enterprise",
            metaType: "SalesArea",
            metaWbId: metaWbId,
            wbMasterDataSetId: wbMasterDataSetId,
            entityId: "SalesArea",
            entityName: "Sales Area",
            dimensionId: "Enterprise"
        })

    }

    get EntityMetaData_Company(): IEntityMetaData { return this._emdCompany }
    get EntityMetaData_SalesOrg(): IEntityMetaData { return this._emdSalesOrg }
    get EntityMetaData_SalesArea(): IEntityMetaData { return this._emdSalesArea }

    //</editor-fold>

    //<editor-fold desc = "Default Customer and Product Types operations">
    async createDefaultCustTypes(options?: any): Promise<void> {
        const self = this

        //static list of default customer types
        let dctCustTypes: {[custMId: string]: { defaultName: string}} = {
            'ShipTo': {
                defaultName: "Ship To"
            },
            'SoldTo': {
                defaultName: "Sold To"
            },
            'BillTo': {
                defaultName: "Bill To"
            },
            'PayTo': {
                defaultName: "Pay To"
            },
            'PlanTo': {
                defaultName: "Plan To"
            }
        }

        //check if the default customer types already exists
        //if not then create using the CustomerTypeBO
        for(let key in self.dctCustomerTypes) {
            let checkExists = await self.dbContext.findAll(esWB_Customer_Type, {
                where: {
                    CUSTM_ID: key,
                    WB_MDSET_ID: self.drWB_MasterDataSet.cif.WB_MDSET_ID,
                    DELETED_IND: {neq: '1'}
                }
            })

            if(checkExists.length == 0) {
                let aCustomerTypeBO = new CustomerTypeBO()
                await aCustomerTypeBO.LoadNew({
                    dbContext: self.dbContext,
                    wbMasterDataSetId: self.drWB_MasterDataSet.cif.WB_MDSET_ID,
                    sId: key,
                    sName: self.dctCustomerTypes[key].defaultName
                })
                await aCustomerTypeBO.Save()
            }
        }

        self.ValidateMessageProvider.addMessage({
            code: 'CustomerTypes',
            type: MessageType.Information,
            title: 'Default Customer Types created successfully.',
            description: 'Default Customer Types created successfully.'
        })
        return
    }

    async createDefaultPrdTypes(options?: any): Promise<void> {
        const self = this

        //check if the default product types already exists
        //if not then create using the ProductTypeBO
        for(let key in self.dctProductTypes) {
            let checkExists = await self.dbContext.findAll(esWB_Product_Type, {
                where: {
                    PRDM_ID: key,
                    WB_MDSET_ID: self.drWB_MasterDataSet.cif.WB_MDSET_ID,
                    DELETED_IND: {neq: '1'}
                }
            })

            if(checkExists.length == 0) {
                let aPrdTypeBO = new ProductTypeBO()
                await aPrdTypeBO.LoadNew({
                    dbContext: self.dbContext,
                    wbMasterDataSetId: self.drWB_MasterDataSet.cif.WB_MDSET_ID,
                    sId: key,
                    sName: self.dctProductTypes[key].defaultName,
                    sType: "Product"
                })
                await aPrdTypeBO.Save()
            }
        }

        self.ValidateMessageProvider.addMessage({
            code: 'ProductTypes',
            type: MessageType.Information,
            title: 'Default Product Types created successfully.',
            description: 'Default Product Types created successfully.'
        })
        return
    }
    //</editor-fold>

    //<editor-fold desc = "Job Param">
    _dctJobParamsBySalesOrgId: { [key: number]: IJobParam[] }

    async IJobParam_OnLoadComplete(): Promise<void> {
        this._dctJobParamsBySalesOrgId = {};

        for (const salesOrgRow of this.SalesOrgs) {
            await this.addJobParamForSalesOrg(salesOrgRow)
        }
    }

    get JobParamList(): IJobParam[] {
        return _.flatten(_.values(this._dctJobParamsBySalesOrgId));
    }

    private async addJobParamForSalesOrg(salesOrgRow: WB_SalesOrgRow): Promise<void> {
        const jobParams: IJobParam[] = await this.getJobParamsForSalesOrg(salesOrgRow);
        this._dctJobParamsBySalesOrgId[salesOrgRow.cif.WB_SALESORG_ID] = jobParams;
    }

    private async removeJobParamForSalesOrg(salesOrgRow: WB_SalesOrgRow): Promise<void> {
        const jobParams: IJobParam[] = this._dctJobParamsBySalesOrgId[salesOrgRow.cif.WB_SALESORG_ID];
        const deleteTasks: Promise<void>[] = [];
        for (const jobParam of jobParams) {
            deleteTasks.push(jobParam.Delete(false));
        }
        await Promise.all(deleteTasks);
    }

    private async getJobParamsForSalesOrg(salesOrgRow: WB_SalesOrgRow): Promise<IJobParam[]> {
        const wbSalesOrgId = salesOrgRow.cif.WB_SALESORG_ID;
        
        const jobParamSettingsForSalesOrg: IJobParamCreateLoadOptions[] = [
            {
                JobSchedulerModuleId: "SnapshotArchivingScheduler",
                JobProcessorType: "SnapshotArchiveProcessor",
                DependentTriggerId: "SnapshotArchive",
            },
            {
                JobSchedulerModuleId: "",
                JobProcessorType: "PEACalcQueuePopulator",
                DependentTriggerId: "PEACalc",
            },
            {
                JobSchedulerModuleId: "",
                JobProcessorType: "TPMCalcQueuePopulator",
                DependentTriggerId: "TPMCalc",
            },
            {
                JobSchedulerModuleId: "",
                JobProcessorType: "BOMExpanderProcessor",
                DependentTriggerId: "BOMExpander",
            },
            {
                JobSchedulerModuleId: "",
                JobProcessorType: "TacticHierSyncProcessor",
                DependentTriggerId: "TacticSync",
            },
            {
                JobSchedulerModuleId: "",
                JobProcessorType: "ProductUOMSyncProcessor",
                DependentTriggerId: "UOMSync",
            },
            {
                JobSchedulerModuleId: "",
                JobProcessorType: "PPGUOMSyncProcessor",
                DependentTriggerId: "UOMSync",
            },
        ];

        const jpMgr = new JobParamManager();
        const findOrCreateTasks: Promise<IJobParam>[] = [];
        for (const setting of jobParamSettingsForSalesOrg) {
            findOrCreateTasks.push(jpMgr.findOrCreate({
                ...setting,
                dbContext: this.dbContext,
                sourceType: "EnterpriseStructureSalesOrg",
                sourceWbId: wbSalesOrgId,

                appExecId: "EnterpriseStructure",
                wbTargetId: this.WB_MasterDataSet.cif.WB_MDSET_ID,

                wbMasterDataSetId: this.WB_MasterDataSet.cif.WB_MDSET_ID,
                wbCompanyId: salesOrgRow.cif.WB_COMPANY_ID,
                wbSalesOrgId: wbSalesOrgId,

                JobParamId: salesOrgRow.cif.SALESORG_ID,
                JobParamName: salesOrgRow.cif.SALESORG_NAME,
            }));
        }
        const jobParams: IJobParam[] = await Promise.all(findOrCreateTasks);
        return jobParams;
    }

    //</editor-fold>

    //<editor-fold desc = "IRecordResolver operations">

    static createRecordResolver(boLoadOptions: any): ESRecordResolver {

        let opts = boLoadOptions || {}
        let dbContext: PAdbContext

        if ('dbContext' in opts) {
            dbContext = opts.dbContext;
        } else {
            dbContext = new PAdbContext({});
        }
        const mdset_options: CreateOptions = {
            standardConditions: {
                [esWB_Set]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Source]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Source_SetType]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Company]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Company_Text]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_SalesOrg]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_SalesOrg_Text]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Division]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_Division_Text]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_DistribChannel]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_DistribChannel_Text]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_SalesArea]: {"DELETED_IND": {"notIn": ['1']}},
                [esWB_SalesArea_Text]: {"DELETED_IND": {"notIn": ['1']}}
            },
            dctIncludeBelongsToNamedRelations: {},
            dctExcludeHasManyNamedRelations: {
                [esWB_SalesOrg]: [esWB_LiftAPI, esWB_Customer_Calendar, esWB_Customer_External_Relationship]
            }
        }

        const aRecResolver = new ESRecordResolver(dbContext, mdset_options)

        return aRecResolver;

    }

    static setupRecordResolver(recordResolver: ESRecordResolver, ids: string[] | number[]): Promise<void> {

        return new Promise<void>((resolve, error) => {
            recordResolver.findAllWithRelationships(esWB_MasterData_Set, ids).then((result) => {
                resolve()
            }).catch((err) => {
                error(err)
            })
        })
    }

    static concurrentLoadCountHint(): number {
        return 10;
    }

    //</editor-fold>

};
PAEnvironment.registerBusinessObjectClass(MasterDataSetBO, "MasterDataSetBO", "Master Data Set")
